import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Layout from "../components/layout"
import { HomeSEO } from "../components/seo"
import Articles from "../components/articles"
import Tags from "../components/tags"

import useSiteMetadata from "../hooks/use-site-metadata"

const H1 = styled.h1`
  font-size: 31px;
  font-weight: ${props => props.theme.title.w};
  line-height: 1.2;
  margin-bottom: 40px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 48px;
    margin-bottom: 80px;
  }

  @media only screen and (min-width: ${props => props.theme.mq.medium}) {
    width: calc(100% / 3 * 2);
  }
`

const Section = styled.section`
  &:not(:first-of-type) {
    margin-top: 80px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      margin-top: 130px;
    }
  }
`

const H2 = styled.h2`
  font-size: 13px;
  font-weight: ${props => props.theme.title.w};
  line-height: ${props => props.theme.title.lhd};
  margin-bottom: 15px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 18px;
    margin-bottom: 20px;
  }
`

const H4 = styled.h4`
  font-size: 12px;
  font-weight: ${props => props.theme.title.w};
  line-height: ${props => props.theme.title.lhd};
  margin: 30px 0 15px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    margin: 45px 0 20px;
  }
`

const Home = () => {
  const data = useStaticQuery(graphql`
    query {
      allCrossCastMagCategory(filter: { parentId: { eq: null } }) {
        edges {
          node {
            slug
            name
            postsInMainCategories {
              slug
              title
              abstract
              featuredImage {
                guid
                platformSlug
                type
                alt
                width
                height
                ext
              }
              category {
                name
              }
            }
            subcategories {
              slug
              name
            }
          }
        }
      }
    }
  `)

  const { claim: siteClaim, lang } = useSiteMetadata()
  const { edges: categories } = data.allCrossCastMagCategory

  return (
    <Layout>
      <HomeSEO />
      <H1>{siteClaim}</H1>
      {categories.map(({ node: category }) =>
        category.postsInMainCategories ? (
          <Section key={category.slug}>
            <H2>{category.name}</H2>
            <Articles posts={category.postsInMainCategories.slice(0, 7)} className="first-hot" />
            {category.subcategories && (
              <>
                <H4>
                  {lang === `it` ? `Scopri tutto in` : `Discover more in`}
                  {` `}
                  {category.name.toLowerCase()}
                </H4>
                <Tags tags={category.subcategories} />
              </>
            )}
          </Section>
        ) : null
      )}
    </Layout>
  )
}

export default Home
